import styled from 'styled-components'
import { colors } from 'styles'

const StyledVirtualHottieTag = styled.span`
  position: relative;
  display: inline-block;
  height: fit-content;
  align-self: center;

  img {
    display: block;
  }

  .virtual-hottie {
    float: right;
    width: 84px;
    height: 15px;
    background-size: contain;
  }

  .tooltip-text {
    width: 250px;
    visibility: hidden;
    background: rgba(0, 0, 0, 0.8);
    color: #fff;
    text-align: center;
    border-radius: 4px;
    padding: 4px 8px;
    position: absolute;
    z-index: 1000;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity 0.1s ease-in;

    a {
      color: ${colors.cta};
      text-decoration: underline;
    }
  }

  &:hover .tooltip-text,
  .tooltip-text:hover {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }

  @media screen and (max-width: 600px) {
    .virtual-hottie {
      margin: 0;
    }
  }

  &:hover .tooltip-text,
  .tooltip-text:hover {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }
`
export default StyledVirtualHottieTag
